export enum PickerType {
  ClientCertificate,
  CertificateAuthority,
}
